export default __webpack_public_path__ + "static/media/btn_delete_user.0296ccd8.svg";